import React from 'react';

/**
 * WegooLoader — animação de carregamento da WEGOO.
 * Marca "WEGOO" em cascata + três pontinhos a "processar". Sem imagens
 * (a ilustração anterior do entregador foi removida por questões de direitos).
 */
export default function WegooLoader({ label = 'A processar...', fullscreen = false }) {
  return (
    <div className={`wegoo-loader-wrap ${fullscreen ? 'is-fullscreen' : ''}`} role="status" aria-live="polite" data-testid="wegoo-loader">
      <style>{cssText}</style>

      <div className="wegoo-stage">
        {/* Letras WEGOO */}
        <div className="wegoo-word" aria-hidden="true">
          <span className="wl wl-w">W</span>
          <span className="wl wl-e">E</span>
          <span className="wl wl-g">G</span>
          <span className="wl wl-o1">O</span>
          <span className="wl wl-o2">O</span>
        </div>

        {/* Pontinhos a processar */}
        <div className="wegoo-spinner" aria-hidden="true">
          <span className="dot d1" />
          <span className="dot d2" />
          <span className="dot d3" />
        </div>

        {label && <p className="wegoo-label">{label}</p>}
      </div>
    </div>
  );
}

const cssText = `
.wegoo-loader-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.wegoo-loader-wrap.is-fullscreen {
  position: fixed;
  inset: 0;
  background: linear-gradient(135deg, #FF8A4C 0%, #FF6B35 55%, #E85D2A 100%);
  z-index: 9999;
  padding: 0;
}

.wegoo-stage {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
}

/* ---- Palavra WEGOO ---- */
.wegoo-word {
  display: flex;
  gap: 4px;
  font-family: 'Inter', system-ui, sans-serif;
  font-weight: 900;
  font-size: 56px;
  letter-spacing: -3px;
  line-height: 1;
  height: 60px;
}
.wegoo-word .wl {
  display: inline-block;
  color: #FFFFFF;
  text-shadow: 0 4px 0 rgba(0,43,56,0.35), 0 0 22px rgba(255,255,255,0.4);
  transform: translateY(60px) rotate(-15deg) scale(0.6);
  opacity: 0;
  animation: wl-pop 2.6s ease-out infinite;
}
.wegoo-word .wl-w  { animation-delay: 0.0s; }
.wegoo-word .wl-e  { animation-delay: 0.12s; }
.wegoo-word .wl-g  { animation-delay: 0.24s; }
.wegoo-word .wl-o1 { animation-delay: 0.36s; }
.wegoo-word .wl-o2 { animation-delay: 0.48s; }

@keyframes wl-pop {
  0%, 8%    { transform: translateY(60px) rotate(-15deg) scale(0.6); opacity: 0; }
  24%       { transform: translateY(-8px) rotate(6deg) scale(1.12); opacity: 1; }
  36%, 85%  { transform: translateY(0) rotate(0deg) scale(1); opacity: 1; }
  100%      { transform: translateY(0) rotate(0deg) scale(1); opacity: 0; }
}

/* ---- Pontinhos ---- */
.wegoo-spinner {
  display: flex;
  gap: 8px;
}
.wegoo-spinner .dot {
  width: 12px; height: 12px; border-radius: 50%;
  background: #FFFFFF;
  box-shadow: 0 0 10px rgba(255,255,255,0.7);
  animation: dot-bounce 1s ease-in-out infinite;
}
.wegoo-spinner .d2 { animation-delay: 0.15s; }
.wegoo-spinner .d3 { animation-delay: 0.30s; }

@keyframes dot-bounce {
  0%, 100% { transform: translateY(0); opacity: 0.5; }
  50%      { transform: translateY(-9px); opacity: 1; }
}

.wegoo-label {
  margin: 4px 0 0;
  color: rgba(255,255,255,0.98);
  font-family: 'Inter', system-ui, sans-serif;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.2);
}
.wegoo-loader-wrap:not(.is-fullscreen) .wegoo-word .wl {
  color: #FF6B35;
  text-shadow: none;
}
.wegoo-loader-wrap:not(.is-fullscreen) .wegoo-spinner .dot {
  background: #FF6B35;
  box-shadow: none;
}
.wegoo-loader-wrap:not(.is-fullscreen) .wegoo-label {
  color: #004E64;
  text-shadow: none;
}

@media (prefers-reduced-motion: reduce) {
  .wegoo-word .wl,
  .wegoo-spinner .dot {
    animation-duration: 0.001s !important;
    animation-iteration-count: 1 !important;
  }
}
`;
